export const getCurrencyFromSettings = (currencySettings: any[], currency: string, network: string) => {
  return currencySettings.find(
    (item) =>
      item.currency_id.toLowerCase() === currency?.toLowerCase() && item.network.toLowerCase() === network?.toLowerCase()
  );
};
